import React, { Component } from 'react';
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';
import BusquedaGrupoWindows from './BusquedaGrupoWindows.jsx';

class PopUpEdicion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newNameProfile: "",
            newDescriptionProfile: "",
            productoId: (props.productoId) ? props.productoId : 0,
            clean: false,
            profileId: (props.profileSelected && props.profileSelected.id) ? props.profileSelected.id : 0
        }
    }

    updateProfile = () => {
        let isAD = (this.props.configuracionSesion.VincularGrupoWindows == true && this.props.configuracionSesion.TipoSeguridad == 'AD');
        let nombreEdicionPerfil = this.state.newNameProfile;

        nombreEdicionPerfil = nombreEdicionPerfil.trim();
        this.props.editarPerfil(this.props.nameProfile, nombreEdicionPerfil, this.props.descripcion, this.state.newDescriptionProfile,
            this.state.productoId, this.props.data.profileSelected.gruposWindows, isAD);

        this.setState({ newNameProfile: nombreEdicionPerfil, newDescriptionProfile: this.state.newDescriptionProfile, productoId: this.props.productoId, clean: true, profileId: this.state.profileId });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.editErrorMessage.length == 0 && nextProps.editErrorMessageDescripcion.length == 0 && this.state.clean && nextProps.descripcion.length > 0 && nextProps.data.profileSelected && nextProps.data.profileSelected.id != 0) {
            this.setState({
                newNameProfile: nextProps.nameProfile,
                newDescriptionProfile: nextProps.descripcion,
                productoId: nextProps.productoId ? nextProps.productoId : 0,
                clean: false,
                profileId: nextProps.data.profileSelected.id
            });
        } else if (nextProps.data.profileSelected && nextProps.data.profileSelected.id != this.state.profileId) {
            this.setState({
                newNameProfile: nextProps.nameProfile,
                newDescriptionProfile: nextProps.descripcion,
                productoId: nextProps.productoId ? nextProps.productoId : 0,
                profileId: nextProps.data.profileSelected.id
            });
        }
    }

    clean = () => {
        this.setState({ newNameProfile: this.props.nameProfile, newDescriptionProfile: this.props.descripcion, productoId: this.props.productoId, clean: true, profileId: null });

        this.props.limpiarMensajes();
    }

    onChange = (e) => {
        this.setState({ newNameProfile: e.target.value });
    }

    onChangeDescription = (e) => {
        this.setState({ newDescriptionProfile: e.target.value });
    }

    onChangeProduct = (e) => {
        this.setState({ productoId: e.target.value });
    }

    updateGroupWindows(event) {
        let value = event.target.dataset.value;
        let checked = event.target.checked;

        if (checked) {
            this.props.addGroupWindowsEdit(parseInt(value), this.props.data.profileSelected.id);
        } else {
            this.props.deleteGroupWindowsEdit(parseInt(value), this.props.data.profileSelected.id);
        }
    }

    render() {
        const { props } = this;

        let selec;

        let products = JSON.parse(JSON.stringify(props.data.productos));
        products.shift();
        products.unshift({ Id: 0, Descripcion: "Todos" });

        let oProducto = products.map((product) => {
            selec = product.Id == this.state.productoId ? true : false;
            return <GenericOption selected={selec} id={product.Id} description={product.Descripcion} key={"NewProduct_" + product.Id} />
        });

        let gruposWindows = [];
        let oGruposWindows;
        let gruposWindowsSeleccionados = [];

        if (props.gruposWindows != undefined) {
            gruposWindows = JSON.parse(JSON.stringify(props.gruposWindows));

            gruposWindows.forEach(function (grupo) {
                if (grupo.Selected)
                    gruposWindowsSeleccionados.push(grupo);
            })
        }

        return (
            <div className="modal fade-out" id="editProfileModal" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header" style={{ height: "70px" }} data-label="Título">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label className="ti-close clickable" onClick={this.clean}></label>
                            </div>
                            <h2 className="modal-title">Editar el perfil</h2>
                        </div>

                        <div className="modal-body modal-perfiles-body">

                            <div className="form-group" data-label="Campo nombre del perfil (Editar)">
                                <label className="label-primary">Nombre del perfil</label>
                                <input id="nombre_perfil_1" className="form-control default-input" type="text" value={this.state.newNameProfile}
                                    placeholder="Nombre del perfil"
                                    onChange={this.onChange} maxLength="50" autoComplete="off" />
                                {props.editErrorMessage &&
                                    <label className="error zmdi-alert-circle">
                                        {props.editErrorMessage}
                                    </label>}
                            </div>

                            <div className="form-group" data-label="Descripción">
                                <label className="label-primary">Descripción</label>
                                <input id="nombre_perfil_2" className="form-control default-input" type="text" value={this.state.newDescriptionProfile}
                                    placeholder="Descripción del perfil"
                                    onChange={this.onChangeDescription} maxLength="50" autoComplete="off" />
                                {props.editErrorMessageDescripcion &&
                                    <label className="error zmdi-alert-circle">
                                        {props.editErrorMessageDescripcion}
                                    </label>}
                            </div>


                            <div className="form-group bottom-separator-xs">
                                <label className="label-primary">Asociar con sistema</label>
                                <select disabled id="selProductos"
                                    value={this.state.productoId}
                                    className="form-control default-select" >                                                                      
                                    {oProducto}
                                </select>


                               { /* <GenericSelect disabled id="selProductos" options={oProducto} onChange={this.onChangeProduct}
                                    className="form-control default-select" />*/}
                            </div>

                            {/*
                            {(props.configuracionSesion.TipoSeguridad == 'AD'
                                && gruposWindows) &&
                                <BusquedaGrupoWindows gruposWindows={gruposWindows}
                                    gruposWindowsSeleccionados={gruposWindowsSeleccionados}
                                    addGroupWindows={props.addGroupWindowsEdit}
                                    deleteGroupWindows={props.deleteGroupWindowsEdit} />}
                            */}
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <button type="button" className="btn btn-primary btn-cta" onClick={this.updateProfile}>Guardar</button>
                                </div>
                                <div className="col-xs-7">
                                    <button type="button" className="btn btn-default btn-secondary" data-dismiss="modal" onClick={this.clean}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopUpEdicion;